export const locale = {
  lang: 'de',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': 'Weiter',
        'ANTERIOR': 'Zurück',
        'FINALIZAR': 'Beenden',
        'ACEPTAR': 'Ich akzeptiere die technischen Anforderungen'
      },
      'MENSAJES': {
        'CONFREQ': 'Sie haben die technischen Anforderungen der Plattform erfolgreich akzeptiert',
        'OK':'OK',
      },
      'CABECERA':{
        'TITULO': 'IT-Anforderungen',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': 'Anforderungen an die Mitarbeiter',
        'SUB_TITULO': '1. Anforderungen an die Anwendung',
        'SUB_TITULO2': '2. Anforderungen an die Browserkapazität',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'Betriebssysteme',
          'TD_LABEL_RECOMENDADO': 'oder höher. (EMPFOHLEN)',
          'TD_NAVEGADOR': 'Browser',
          'TD_LABEL_SUPERIOR': 'oder höher',
          'TD_LABEL_LASTVERSION': '(letzte Version)',
          'TD_LABEL_LASTVERSION_MIN': '(letzte Version, mindestens Version 12.3)'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Sicherheitszertifikat',
          'TD_COOKIES': 'Cookies erlaubt',
          'TD_CIFRADO': 'TLS-Verschlüsselung',

          'TD_CONTENT1': 'Stellen Sie sicher, dass das Sicherheitszertifikat oder die Autorität Lets Encrypt Authority X3 gewährt, die von Ihrer Organisation als zuverlässig eingestuft wird',
          'TD_CONTENT2': 'Der Browser muss JavaScript 1.2 aktiviert haben',
          'TD_CONTENT3': 'Die Server der CulturalGo Platform verarbeiten Cookies, die keine Informationen über den Benutzer oder sein Betriebssystem sammeln. Sie sind jedoch für den Betrieb der Umfrage erforderlich und müssen aktiviert sein.',
          'TD_CONTENT4': 'Je nach Art des Projekts benötigt eines unserer Berichtsmodule nur TLS-Verschlüsselung'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'Wenn der Kunde beabsichtigt, andere Betriebssysteme wie LINUX, UNIX, ChromeOS oder mobile Plattformen zu verwenden, ist der Kunde dafür verantwortlich, sicherzustellen, dass seine Browsersoftware mit der Umfrage gut funktioniert.',
          'SUBPARRAFO2': 'Als Reaktion auf die POODLE-Schwachstelle (CVE-2014-3566) und die Einstellung des Supports für Windows XP durch Microsoft wird Great Place den Zugriff auf unsere gesicherten Websites von Computern mit Windows XP nicht mehr vollständig unterstützen. Great Place wird den Support für Computer mit Windows XP beibehalten, die die in den Anwendungsanforderungen aufgeführten Versionen der Browser Chrome oder Firefox verwenden. Der Zugriff mit anderen Browsern kann weiterhin möglich sein; diese Browser werden jedoch nicht getestet oder unterstützt.',
        },
        'ADVERT': 'HINWEIS: Ab Version 5.0 von Cultural Go wird die Unterstützung für den Microsoft Internet Explorer entfernt.'
      },
      'PASO2':{
        'TITULO': 'Umfrage-Authentifizierung',
        'SUB_TITULO1': '3. Zertifikate',
        'SUB_TITULO2': '4. Laptop / Computer des Mitarbeiters',
        'SUB_TITULO3': '5. Umfragebeantwortung von mobilen Geräten',
        'SUB_TITULO4': '1. Zu berücksichtigende Fragen',
      'SUB_TITULO5': '2. Sprachhilfe',
        'PARRAFO1': 'Cultural GO verwendet das Lets Encrypt Authority X3 SSL-Zertifikat, das von der Internet Security Research Group (ISRG) bereitgestellt wird. Wenn das Zertifikat nicht installiert ist, wird dem Benutzer eine Sicherheitswarnseite angezeigt, die ihn darüber informiert, dass es ein Problem mit dem Sicherheitszertifikat der Website gibt. Der Benutzer kann entweder wählen, ob er mit dem Zugriff auf die Website fortfahren möchte oder ob er weitere Informationen über das Problem anzeigen lassen möchte. Auch wenn der Benutzer auf der Website navigieren darf, wird die Warnmeldung weiterhin bei jedem Besuch der Website angezeigt.',
        'PARRAFO2':{
          'LINEA1':'Um auf die Online-Umfrage zugreifen zu können, benötigt der Computer/Laptop des Mitarbeiters:',
          'LINEA2':'Voller Zugriff auf die Webadresse der Umfrage (Bitte stellen Sie sicher, dass der Benutzer die richtigen Rechte hat, falls er eine Firewall hat.)',
          'LINEA3':'Für den Fall, dass die Umfrage LINK per Post verschickt wird, muss der Benutzer Zugriff auf sein Firmen-E-Mail-Konto haben.',
        },
        'PARRAFO3': 'Die Umfragen wurden auf mobilen Geräten wie Tablets und Telefonen validiert. Die Darstellung und Anordnung der Umfrageelemente wird an die Auflösung des Bildschirmgeräts angepasst. Die Ausführung der Umfrage ist abhängig vom Modell des Geräts.',

        'PARRAFO4': 'Die Umfrage wurde so gestaltet, dass sie auf den vertikalen Bildschirmen von mobilen Geräten mit Full-HD-Auflösung ein angenehmes Benutzererlebnis bietet.',

        'PARRAFO5': 'In einigen Organisationen gewähren WiFi-Netzwerke keinen vollständigen Zugriff auf persönliche Geräte. Wenn der Benutzer also beschließt, sein persönliches Gerät zu verwenden und eine Verbindung über ein WiFi-Netzwerk herzustellen, muss er bestätigen, dass er Zugriff auf die Umfrage-Website hat.',

        'PARRAFO6': 'Benutzer sollten berücksichtigen, dass bei der Verwendung einer direkten Verbindung zu ihrem Mobilfunkanbieter Navigationsgebühren anfallen können.',
        'PARRAFO7':{
          'LINEA1':'Die Benutzer erhalten Zugang zur Website über eine bestimmte URL, die pro Projekt generiert wird. Die Links enthalten keine Informationen über den Benutzer.',
          'LINEA2':'Ein eindeutiger Benutzercode muss in die sichere globale URL eingegeben werden, um den Zugang zur Umfrage zu ermöglichen.',
          'LINEA3':'Jeder eindeutige Benutzercode wird den Benutzern zur Verfügung gestellt, entweder per E-Mail, SMS oder manuell durch den Personalleiter (oder eine gleichwertige Position).',
        },
        'PARRAFO8':{
          'LINEA1':'1. Der Kunde muss die Zustellung der Einladungen per E-Mail an seine Mitarbeiter überwachen:',
          'LINEA2':'Wenn der E-Mail-Server ausgelagert ist, kontaktieren Sie bitte vorher den E-Mail-Provider, um die Anforderungen mitzuteilen.',
          'LINEA3':'Wenn der E-Mail-Server in ihren Räumlichkeiten steht, bitten Sie die IT-Abteilung um Unterstützung.',
          'LINEA4':'Hinweis: Beim Versand der Einladungen zur Beantwortung der Umfrage werden keine kostenlosen Dienste wie: Hotmail, Gmail, Yahoo, etc.',
          'LINEA5':'2. Wenn die Client-Firmen-E-Mail OUTLOOK WEBACCESS ist, müssen die Mitarbeiter den Weblink kopieren und im Webbrowser öffnen, andernfalls wird ein Fehler erzeugt.',
          'LINEA6':'3. Wenn die Umfrage auf dem Computer oder Gerät, auf dem die Umfrage durchgeführt wird, länger als 30 Minuten inaktiv ist, wird ein "TIME OUT" generiert, und die Mitarbeiter müssen sich mit demselben Benutzer und Kennwort erneut an der Umfrage anmelden. Das System bringt die Benutzer genau zu der Frage, bei der sie waren',
          'LINEA7':'Jede Antwort wird gespeichert, wenn sie ausgewählt wird. Der Benutzer kann keine andere Antwort auswählen, bis der Speichervorgang abgeschlossen ist, wodurch sichergestellt wird, dass der Fortschritt des Benutzers bei der Beantwortung der Umfrage impliziert, dass alle ausgewählten Antworten gespeichert wurden.'
        },
        'PARRAFO9':{
          'LINEA1':'Unsere Umfrage unterstützt nur die in der Sprachauswahl eingestellten Sprachen und kann nur am Anfang der Umfrage ausgewählt werden.',
          'LINEA2':'Falls die ausgewählten Sprachen in einer anderen Sprache sind, die Sonderzeichen erfordert, muss der Benutzer sicherstellen, dass sein Browser die Schriftarten unterstützt.',
          'LINEA3':'In der Regel haben alle Benutzer, die die Umfrage in einer ostasiatischen Sprache oder einer anderen Sprache, die Sonderzeichen erfordert, anzeigen möchten, bereits Sprachpakete installiert, so dass dies möglicherweise nicht für alle Benutzer erforderlich ist, außer für einige wenige.',
          'LINEA4':'Für jede projektspezifische Anforderung, eine bestimmte Schriftart auf der Online-Seite zu verwenden, müssen die Benutzer diese spezielle Schriftart auf jedem ihrer jeweiligen Rechner installiert haben. Wann immer erforderlich, wird Great Place solche Anforderungen an das Projektteam des Kunden kommunizieren.',
        },
        'PARRAFO10': 'Wichtig: Der Benutzer muss sicherstellen, dass der Browser nicht die automatische Übersetzungsfunktion aktiviert hat, da sonst die Sprachauswahl möglicherweise nicht funktioniert.',
      },
      'PASO3':{
        'TITULO': 'Anforderungen an die Internetverbindung',
        'SUB_TITULO1': '1. Anforderungen an die SSL-Verschlüsselung',
        'SUB_TITULO2': '2. Rbandbreiten-Anforderungen',
        'SUB_TITULO3': '3. Firewall-Whitelists: Webserver-IP und Domain-Zugriff',
        'SUB_TITULO4': '4. Firewall-Whitelists: E-Mail-Server',
        'SUB_TITULO5': '5. Generierung von Antwortgruppen (Kioskos)',
        'PARRAFO1': 'Der Client-Webbrowser sollte SSL-fähige Seiten unterstützen. Dies ermöglicht dem Benutzer ein Höchstmaß an Vertraulichkeit von personalisierten Informationen.',

        'PARRAFO2': 'Die Bandbreite hängt von der Art der Umfrage und der Berichte ab, die eingesetzt werden, sowie von den Komponenten - Video, Flash und Bilder - die in der Lösung verwendet werden. Für Umfragen mit diesen Komponenten beträgt die empfohlene Verbindung 1+ Mbit/s pro Benutzer. Die Benutzerfreundlichkeit wird beeinträchtigt, wenn eine niedrigere Verbindung verwendet wird. Für Umfragen ohne diese Komponenten ist eine normale Verbindung zum Internet erforderlich.',
        'PARRAFO3':{
          'LINEA1':'Damit die Umfrage und die Berichtsseiten auf Cultural Go funktionieren, sollten folgende Domains und IP-Adressen auf der White-List stehen:',
          'LINEA2':'Es ist wichtig, den folgenden Domains und IP-Adressen die notwendigen Berechtigungen zu erteilen, um Mitarbeitern den Zugriff auf die Great Place to Work® Trust Index ©Umfrage zu ermöglichen.',},
          'PARRAFO31': 'Wichtig: Die gesamte Domain muss für die Benutzer verfügbar sein (muss Zugriff auf die gesamte Site gewähren)',

          'PARRAFO4':{
            'LINEA1':'Es ist erforderlich, dass der Mail-Server den folgenden E-Mail-Adressen vollen Zugriff gewährt:',
            'LINEA2':'Es ist notwendig, dass auf Ihrem Mail-Server folgende Berechtigungen vergeben werden, um zu vermeiden, dass E-Mails von Great Place als SPAM klassifiziert werden:',
          },
          'PARRAFO5':{
            'LINEA1':'Wichtig:',
            'LINEA2':'Diese Einstellung soll verhindern, dass die E-Mail-Adresse als SPAM erkannt wird',
            'LINEA3':'Der Mailserver muss in der Lage sein, Tausende von E-Mails von demselben Konto zu erhalten',
            'LINEA4':'Fügen Sie in den Sicherheitsregeln Ihres E-Mail-Providers die Domains für das Whitelisting hinzu, und wenn möglich, fügen Sie sie als Kontakt-E-Mail-Konten hinzu',
          },
        'PARRAFO6': 'In vielen Organisationen ist es üblich, mehrere Computer aufzustellen, damit die Benutzer Umfragen in Gruppen beantworten können. Daher ist es notwendig, Bandbreitentests der Ausgänge zum Internet durchzuführen, um sicherzustellen, dass die Verbindungsgeräte den gesamten Datenverkehr, der durch die Beantwortung in Gruppen entsteht, unterstützen.',
        'PARRAFO7': 'Es wird empfohlen, dass, bevor die Benutzer mit der Beantwortung in der Gruppe beginnen, ein Spezialist aus dem IT-Bereich überprüft, dass es keine Probleme mit der Internetverbindung geben wird.',
        'TABLA1':{
          'TD_ELEMENTO':'Element',
          'TD_REGION1':'Region México',
          'TD_REGION2':'Region Mittel- und Südamerika',
          'TD_REGION3':'Region Asien',
          'TD_REGION4':'Region Europa',
          'TD_DOMINIO':'Bereich',
          'TD_SUBDOMINIO':'Unter-Domäne',
          'TD_DIRECCION':'IP-Richtung',
          'TD_PUERTOS':'Ports',

        },
        'TABLA2':{
          'TD1':'Absender-Mail-Konten:',
          'TD2':'Domain'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'Anwendung',
          'TD_ELEMENTO02':'Domäne',
          'TD_ELEMENTO03':'IP',
          'TD_ELEMENTO04':'Port',
          'TD_ELEMENTO05':'Subdomain',
        },
        'TITLE1':'Domain: CulturalGo.com',
        'TITLE2':'Domain: gptw.global',
      },
      'PASO4':{
        'TITULO': 'Service-Levels',
        'SUB_TITULO1': '1. Support',
        'SUB_TITULO2': '2. Systemverfügbarkeit',
        'SUB_TITULO3': '3. überwältigende Kraft',
        'SUB_TITULO4': '4. Gleichzeitigkeit',
        'SUB_TITULO5': '5. Wartungsfenster',
        'TABLA1':{
          'TD_REGION1':'Region México',
          'TD_REGION2':'Region Mittel- und Südamerika',
          'TD_REGION3':'Region Asien',
          'TD_REGION4':'Region Europa'
        },
        'PARRAFO1':{
          'LINEA1':'Verfügbarkeit der Anwendung = 99,5%',
          'LINEA2':'Um die Systemverfügbarkeit zu gewährleisten, wird die Anwendung 24 Stunden am Tag, 7 Tage die Woche und 365 Tage im Jahr überwacht. Mit einem Alarmierungssystem und Supportverfahren.',
        },
        'PARRAFO2': 'Höhere Gewalt sind Ereignisse, die außerhalb der zumutbaren Kontrolle einer Partei liegen, einschließlich, aber nicht beschränkt auf höhere Gewalt, Krieg, Streiks, behördliche Anordnungen, zivile Unruhen oder terroristische Handlungen oder Erdbeben, die es für diese Partei rechtlich undurchführbar, illegal oder unmöglich machen, ihre Pflichten zu erfüllen.',
        'PARRAFO3': 'Der Service-Level für die Systemverfügbarkeit deckt keine Leistungsausfälle ab, die durch die Nichterfüllung der hierin festgelegten technischen Anforderungen durch den Kunden oder durch ein als höhere Gewalt eingestuftes Ereignis verursacht werden',
        'PARRAFO4': 'Die Datenerfassungsumgebung kann 10.000 gleichzeitige Benutzer oder bis zu 1,5 Millionen Umfrageausfüllungen in einem Zeitraum von 24 Stunden unterstützen. Die Berichtsanwendung kann 500 gleichzeitige Benutzer oder bis zu 1.000 Berichtssitzungen in einem Zeitraum von 24 Stunden unterstützen.',
        'PARRAFO5':{
          'LINEA1':'Great Place behält sich das Recht vor, die Umfrage- und Berichtsanwendung für geplante Wartungsarbeiten herunterzufahren. Geplante Wartungspläne werden allen betroffenen Parteien im Voraus mitgeteilt.',
          'LINEA2':'Während des oben genannten Wartungsfensters steht die Anwendung den Nutzern möglicherweise nicht zur Verfügung. Falls Great Place ein erweitertes Wartungsfenster für zusätzliche Aktivitäten benötigt, wird der designierte Kundenkontakt benachrichtigt.',
          'LINEA3':'Für Notfallwartungen wird das Wartungsfenster möglicherweise nicht angekündigt. Für Kunden, die von der Notfallwartung betroffen sind, wird der designierte Kundenkontakt benachrichtigt.'
        },
      },
      'PASO5':{
        'TITULO': 'Datenschutzrichtlinie',
        'SUB_TITULO1': '1. Richtlinie',
        'PARRAFO1': 'Die gesendeten und auf den Servern der CulturalGo-Plattform gespeicherten Informationen werden im Rahmen von Richtlinien und Verfahren geschützt und gesichert, die den Bestimmungen der ISO 27001 entsprechen. Wenn Sie Fragen haben, wenden Sie sich bitte an Ihren Great Place To Work Berater.',
      },
      'VALIDACION':{
        'TITULO': 'Validierung der technischen Anforderungen',
        'DATOSTI':{
          'INFOEMPRESA': 'Unternehmensinformationen',
          'NOMBREEMPRESA': 'Name des Unternehmens',
          'NOMBRE': 'Name des IT-Leiters',
          'EMAIL': 'IT-E-Mail',
          'TEL': 'IT-Telefonnummer',
          'EXT': 'IT-Telefonnummer Durchwahl',
          'CEL': 'IT-Handynummer',
          'TOOLTIP': 'Firmeninformationen anzeigen',
        },
        'TIMELINE':{
          'TITULO': 'Prozess der Validierung der technischen Anforderungen',
          'CARGANDO': 'Informationen laden',
          'PROGRESO': 'Aktueller Fortschritt:',
          'PROGRESO2': 'Fortschritt der technischen Anforderungsvalidierung:',
          'STATUS': {
            'OK': 'Status: Abgeschlossen',
            'NOTOK': 'Status: Nicht abgeschlossen',
            'TOOLTIP': 'Als abgeschlossen markieren',
          },
          'COMENTARIO': {
            'TITULO_1': 'Speichern Sie einen Kommentar zu diesem Schritt',
            'INPUT': 'Geben Sie Ihren Kommentar ein',
            'ENVIAR': 'Kommentar speichern',
            'TITULO_2': 'Kommentare (ältester zuerst)',
            'CANNOT': 'Kommentare können nach Abschluss des Schrittes nicht mehr abgegeben werden',
          },
          'NOMBRES': {
            '1': 'E-Mail an TI-Manager gesendet',
            '2': 'TR Einrichten - Kundenanruf',
            '3': 'TR Einrichten - Test',
            '4': 'Fragebogen gesendet',
            '5': 'Fragebogen fertig',
          }
        },
        'MENSAJES': {
          'NADA': 'Sie haben den Kommentar noch nicht eingegeben, Sie dürfen einen leeren Kommentar nicht speichern',
          'AUNNO': 'Sie können diese Aktion noch nicht durchführen, die Validierung der technischen Anforderungen muss erst abgeschlossen werden',
          'COMPLETAR': 'Bestätigen Sie, den Status dieses Schritts als "abgeschlossen" zu ändern?',
          'COMPLETAR_OK': 'Dieser Schritt wurde erfolgreich auf "Erledigt" geändert',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nein',
          },
          'NOCOMPLETAR': 'Sie dürfen diesen Schritt noch nicht als abgeschlossen markieren, Sie müssen erst den vorherigen Schritt abschließen',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'Technische Anforderungen aktualisiert',
        'MENSAJE_CONEX_OK':'Verbindung erfolgreich',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Technische Anforderungen aktualisiert',
        'MENSAJE_RESPUESTA_REQ':'* Antwort erforderlich',
        'WAR_ING_RUN': 'Mindestens eine E-Mail eingeben',
      },
      'CABECERA':{
        'TITULO': 'Technische Anforderungen',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': 'Weiter',
              'ANTERIOR': 'Zurück',
              'FINALIZAR': 'Beenden',
              'ACEPTAR': 'Ich akzeptiere die technischen Anforderungen'
            },
        'PASO1':{
          'TITULO':'Contributor requirements',
          'SUB_TITULO':'Technische Anforderungen',
          'SUB_TITULO2':'Plataforma CulturalGo® 5.0',
          'TEXTO0_PARTE_1':'Der Zweck dieses Dokuments ist es, über die technischen Anforderungen der CulturalGo®-Plattform zu informieren, um einen einfachen und effektiven Zugang zum Umfragesystem Greate Place to Work®, Trust Index© zu gewährleisten und somit wiederkehrende technische Probleme zu vermeiden.',
          'TEXTO0_PARTE_2':'Es ist wichtig, dass Sie alle technischen Anforderungen für die Mitarbeiter Ihrer Organisation einhalten und überprüfen, um die Umfrage zu empfangen und zu beantworten. Andernfalls ist es sehr wahrscheinlich, dass es zu Komplikationen wie Blockierungen und/oder Schnittstellen kommt, die dazu führen, dass der Kollaborateur die Umfrage nicht empfangen und beantworten kann.',
          'SUB_TITULO3':'Anforderungen an Mitwirkende (Endbenutzer)',
          'SUB_TITULO4':'Anwendungsanforderungen',

          'SUB_TITULO2_CARCA':'Platform CulturalGo® 5.0',
          'TEXTO0_PARTE_1_CARCA':'Der Zweck dieses Dokuments ist es, über die technischen Anforderungen der CulturalGo®-Plattform zu informieren, um einen einfachen und effektiven Zugang zum Umfragesystem Greate Place to Work®, Trust Index© zu gewährleisten und somit wiederkehrende technische Probleme zu vermeiden.',
          'TEXTO0_PARTE_2_CARCA':'Es ist wichtig, dass Sie alle technischen Anforderungen für die Mitarbeiter Ihrer Organisation einhalten und überprüfen, um die Umfrage zu empfangen und zu beantworten. Andernfalls ist es sehr wahrscheinlich, dass es zu Komplikationen wie Blockierungen und/oder Schnittstellen kommt, die dazu führen, dass der Kollaborateur die Umfrage nicht empfangen und beantworten kann.',
          'TEXTO0_PARTE_1_INNMO':'Der Zweck dieses Dokuments ist es, über die technischen Anforderungen der CulturalGo®-Plattform zu informieren, um einen einfachen und effektiven Zugang zum Umfragesystem Innmotion, Trust Index© zu gewährleisten und somit wiederkehrende technische Probleme zu vermeiden.',


          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'Betriebssysteme:',
            'TD_LABEL_RECOMENDADO': 'oder höher (RECOMMENDED)',
            'TD_NAVEGADOR': 'Browser: ',
            'TD_LABEL_SUPERIOR': 'oder höher',
            'TD_LABEL_LASTVERSION': '(letzte Version).',
            'TD_LABEL_LASTVERSION_MIN': '(letzte Version, mindestens Version 12.3).'
          },
          'TEXTO1_PARTE_1':'Wenn der Kunde beabsichtigt, ein anderes als die oben aufgeführten Betriebssysteme zu verwenden, wie z. B. Versionen von LINUX, UNIX, Chrome OS, mobile Betriebssysteme usw., ist der Kunde dafür verantwortlich, dass die Umfrage auf seiner Browsersoftware korrekt ausgeführt wird.',
          'TEXTO1_PARTE_2':'Aufgrund der Sicherheitslücke von POODLE (CVE-2014-3566) und der Beendigung des Supports für Windows XP durch Microsoft wird Great Place to Work® den Zugriff auf unsere sicheren Websites von Computern mit Windows XP nicht mehr unterstützen. Great Place to Work® wird den Support für Computer mit Windows XP aufrechterhalten, die die in den Anwendungsanforderungen aufgeführten Versionen der Browser Chrome oder Firefox verwenden. Der Zugriff mit anderen Browsern kann weiterhin möglich sein; diese Browser werden jedoch nicht getestet oder unterstützt.',
          'TEXTO1_PARTE_2_INNO':'Aufgrund der Sicherheitslücke von POODLE (CVE-2014-3566) und der Beendigung des Supports für Windows XP durch Microsoft wird Innmotion den Zugriff auf unsere sicheren Websites von Computern mit Windows XP nicht mehr unterstützen. Innmotion wird den Support für Computer mit Windows XP aufrechterhalten, die die in den Anwendungsanforderungen aufgeführten Versionen der Browser Chrome oder Firefox verwenden. Der Zugriff mit anderen Browsern kann weiterhin möglich sein; diese Browser werden jedoch nicht getestet oder unterstützt.',
          'TEXTO2_PARTE_1':'Hinweis: Ab Version 5.0 CuturalGo® wird die Unterstützung für den Microsoft Internet Explorer entfernt',
        },
        'PASO2':{
          'TITULO': 'Umfrage-Authentifizierung',
          'SUB_TITULO1': 'Webserver-IP und Domänenzugriff',
          'SUB_TITULO2': ' Firewall-Whitelists:',
          'TEXTO0_PARTE_1': 'Damit Umfrage- und Berichtsseiten auf a Platform CulturalGo® funktionieren, muss Folgendes auf den Whitelists stehen:',
          'TEXTO1_PARTE_1': 'Es ist wichtig, den folgenden Domains und IP-Adressen die notwendigen Berechtigungen zu erteilen, damit Ihre Mitarbeiter auf die Great Place to Work® Trust Index© Umfrage zugreifen können',
          'TEXTO1_PARTE_1_INNMO': 'Es ist wichtig, den folgenden Domains und IP-Adressen die notwendigen Berechtigungen zu erteilen, damit Ihre Mitarbeiter auf die Innmotion Trust Index© Umfrage zugreifen können',
          'BTN_COMPRO_CONEX':'Verbindung prüfen',
          'BTN_SUCCE_CONEX':'Verbindung hergestellt',
          'TOOL_BTN_COMPRO_CONEX':'Service im Aufbau',
          'MODAL_SUCCESS_CONEX':'Die Verbindung war erfolgreich',
          'ETI_INTRUC_DOMA_COPY':'Kopieren und senden Sie diesen Link für den Fall, dass Sie Verbindungen von einem beliebigen dezentralen Zugangspunkt verifizieren müssen (hat keinen Einfluss auf die Validierung der technischen Anforderungen).',
          'BTN_INTRUC_COPY_ENLA':'Link kopieren',
          'MODAL_COPY_ENLA_SUCC':'Link wurde erfolgreich kopiert',

          'SUB_TITULO2_CARCA': 'Firewall whilelists:',
          'TEXTO0_PARTE_1_CARCA': 'Damit Umfrage- und Berichtsseiten auf a Platform CulturalGo® funktionieren, muss Folgendes auf den Whitelists stehen:',
          'TEXTO1_PARTE_1_CARCA': 'Es ist wichtig, den folgenden Domains und IP-Adressen die notwendigen Berechtigungen zu erteilen, damit Ihre Mitarbeiter auf die Great Place to Work® Trust Index© Umfrage zugreifen können',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'Element',
           'TH_REGIONM':'Globale Region',
           'TH_REGIONC':'Region Mittel- und Südamerika',
           'TH_REGIONA':'Region Asien',
           'TH_REGIONE':'Region Europa',
           'TH_DOMINIO_PRINCIPAL':'Hauptdomäne',
           'TH_APLICADOR':'Vermessungsapplikator',
           'TH_PLATAFORMA':'Verwaltungsplattform',
           'TH_ENVOLTURA':'Url-Umschlag',
           'TH_RESULTADOS':'Ergebnisse (Tableau®)',
           'TH_CULTURE':'Kultur Audit®',
           'TH_PORTAL':'Externes Zählportal',
           'TH_SUBDOMINIO':'Subdomäne',
           'TH_DIRECCION_IP':'IP-Adresse',
           'TH_PUERTOS':'Ports',
           'TH_DOMINIO':'Domäne',
           'TEXTO1':'- Alle Links zu den Umfragen werden über den URL-Wrapper 4all.gptw.global/ ausgeliefert, der eine Weiterleitung auf die Seite ﬁnal der für jede Firma zugeordneten Umfrage enthält. ',
           'TEXTO2':'- Aus Sicherheitsgründen können die Algorithmen von CulturalGo® die URL der ﬁnalen Umfrage jederzeit während des Umfragezeitraums ändern. Daher muss immer der Wrapper 4all.gptw.global/ verwendet werden, der während der gesamten Umfrage permanent ist.',
           'TEXTO3':' WICHTIG:',
           'TEXTO4':' Der Link zur Umfrage sollte niemals direkt aufgerufen werden (z.B. http://newsurvey.culturalgo.com/Ax013s203ls), da sich das Token, aus dem die Umfrage besteht, von Zeit zu Zeit ohne Ankündigung ändern kann.',
           'TEXTO5':' Wichtig :',
           'TEXTO6':' Benutzer müssen vollen und uneingeschränkten (unrestricted) Zugriff auf die gesamte Domain haben. ',
           'TEXTO7':' E-Mail-Server',
           'TEXTO8':' Der Mail-Server benötigt Vollzugriff auf folgende E-Mail-Adressen:',
           'TEXTO9':' Auf Ihrem Mailserver sind folgende Berechtigungen erforderlich, um zu verhindern, dass Great Place to Work®-E-Mails als SPAM clasiﬁquen:',
           'TEXTO9_INNMO':' Auf Ihrem Mailserver sind folgende Berechtigungen erforderlich, um zu verhindern, dass Innmotion-E-Mails als SPAM clasiﬁquen:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO': 'E-Mail-Konto des Absenders:',
             'TD_DOMINIO':' Domain:',
             'TD_IP_ADDRE_PRIM':'Primäre IP-Adresse:',
             'TD_SECON_IP':'Sekundäre IP-Adressen:',
             'TD_SUBDOMINIO':'Subdomains für die Umleitung von Links (Sie werden zur Überwachung verwendet):',
           },
           'TEXTO10':'- Diese conﬁguración soll verhindern, dass die E-Mail Adresse als Spam erkannt wird. ',
           'TEXTO11':'- Der Mailserver muss in der Lage sein, Tausende von E-Mails von demselben Konto zu empfangen.',
           'TEXTO12':'- Fügen Sie in den Sicherheitsregeln Ihres E-Mail-Providers die Domains für die Whitelist hinzu und fügen Sie sie, wenn möglich, als Kontakt-E-Mail-Konten hinzu',
           'TEXTO13':'Wenn Sie Unterstützung benötigen, senden Sie eine Nachricht an',
           'BTN_CONFIGURACION':'Domains und IPs wurden konfiguriert',
           'BTN_ACCESO_ENCUESTA':'Ich habe die Tests durchgeführt und hatte keine Komplikationen',
           'BTN_RECIBI_CORREOS':'Ich habe die E-Mails in meinem Posteingang erhalten',

          }
        },
        'PASO3':{
          'TITULO':'Eingangstests',
          'TIT_TES_PRU_ACC_SURV': 'In diesem Abschnitt können Sie einen Visualisierungstest einer generischen Umfrage (ohne Bezug zu Ihren Organisationen) durchführen:',
          'INS2_TES_PRU_ACC_SURV':'1. Klicken Sie auf:',
          'INS1_1_TES_PRU_ACC_SURV':'Schlüssel kopieren',
          'INS1_TES_PRU_ACC_SURV':'2. Rufen Sie den folgenden Link auf:',
          'INS3_TES_PRU_ACC_SURV':'3. Fügen Sie den Schlüssel in die Passwortzelle ein',
          'INS4_TES_PRU_ACC_SURV':'4. Klicken Sie auf Anmelden',

          'TIT_TES_PRU_EM_PILO':'In diesem Abschnitt können Sie einen Test des Mail-Empfangs durchführen',
          'INS1_TES_PRU_EM_PILO':'1. Geben Sie die Emails ein',
          'INS2_TES_PRU_EM_PILO':'2. Klicken Sie auf die Schaltfläche "Testmail senden"',
          'BTN_SE_EMA':'Versenden der Test-Mail',
          'CONTAC':'Bei technischen Fehlern wenden Sie sich bitte an support@itbm.mx und wir werden diese gerne beheben',
          'WARN_TEST_EMAIL':'Um den Vorgang fortzusetzen, haben wir Ihnen einen Bestätigungslink an Ihre E-Mail-Adresse gesendet.',
          'MSJ_SUCC_EMA_': 'Emails wurden erfolgreich gesendet',
          'MODAL_WARNI_BAND':'Um mit dem Prozess fortzufahren, bestätigen Sie den Zugriff auf die Umfrage und/oder den Erhalt der E-Mail',
          'MODAL_VERIFI_INFO':'Überprüfen von Informationen',
          'MSJ_COP_CLA': 'Kopieren des Benutzerschlüssels',
        },
        'PASO4':{
          'TITULO':'Validierungsfragebogen',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Kann ich die Einstellungen ohne Probleme vornehmen?',
            'PREGUNTA_1_INDI':'(Wenn Sie irgendwelche Probleme hatten, bitte angeben)',
            'PREGUNTA_2':'2.-Ihr Mailserver wurde vertraut von:',
            'PREGUNTA_2_INDI1':'a) Ihr internes IT-Team (hat volle Kontrolle über die Konfigurationen).',
            'PREGUNTA_2_INDI2':'b) Ich fordere ein Ticket von Ihrem Provider an (nennen Sie den Namen des Providers)',
            'PREGUNTA_3':'3.-¿Ihre E-Mails sind unter Geschäftskonten (Gmail, Microsoft, Yahoo!, etc.)?',
            'PREGUNTA_4':'4.-¿Haben Sie die Domain gptwonline.com registriert, erinnern Sie sich daran, dass die E-Mails, die Sie erhalten, von dieser Domain stammen, stellen Sie sicher, dass sie nicht in Spam oder Junk-Mail gegangen sind?',
            'PREGUNTA_5':'5.-¿Haben Sie eine Möglichkeit, eine Liste der empfangenen Emails zu erhalten (Email-Log)?',
            'PREGUNTA_6':'6.-¿Welche Internet-Browser haben Ihre Mitarbeiter installiert? (Bitte auflisten; Browser - Version)',
            'PREGUNTA_7':'7.-¿Haben Sie Ihren Mitarbeitern die notwendigen Berechtigungen für die Navigation in der Umfrage erteilt? (Bei Problemen bitte auflisten)',
            'PREGUNTA_8':'8.-¿Haben Sie für die Durchführung Ihrer Umfrage Computerräume für Ihre Mitarbeiter vorgesehen, um die Umfrage zu beantworten?',
            'PREGUNTA_8_INDI1':'(¿(Wenn ja, geben Sie bitte die Anzahl der Räume und die Anzahl der Geräte pro Raum an?)',
          },
          'BTN_VALIDAR_ENVIAR':'Validieren und senden',
        },
        'PASO5':{
          'TITULO': 'Datenschutzrichtlinie',
          'SUB_TITULO':'Datenschutzrichtlinie',
          'PARRAFO1': 'Die auf den Servern der CULTURAL GO®-Plattform gesendeten und gespeicherten Informationen werden im Rahmen von Richtlinien und Verfahren geschützt und gesichert, die der ISO 27001 entsprechen. Sollten Sie Fragen dazu haben, wenden Sie sich bitte an Ihren Great Place To Work® Berater',
          'PARRAFO1_INNMO': 'Die auf den Servern der CULTURAL GO®-Plattform gesendeten und gespeicherten Informationen werden im Rahmen von Richtlinien und Verfahren geschützt und gesichert, die der ISO 27001 entsprechen. Sollten Sie Fragen dazu haben, wenden Sie sich bitte an Ihren Innmotion Berater',
          'PARRAFO2':'Eingetragene Warenzeichen',
          'PARRAFO3_1':'- Great Place to Work® y Trust Index© ',
          'PARRAFO3_2':'sind eingetragene Marken des Great Place To Work Institute USA, in diesem Dokument werden diese Marken nur als Referenz verwendet.',
          'PARRAFO3_1_INNMO':'- Innmotion y Trust Index© ',
          'PARRAFO3_2_INNMO':'sind eingetragene Marken des Innmotion Institute USA, in diesem Dokument werden diese Marken nur als Referenz verwendet.',
          'PARRAFO4_1':'- Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'ist eine eingetragene Marke von Innovación Tecnológica B&M S.A. de C.V. Mexico',
          'PARRAFO4_2':'und generell die gesamte Go!®-Plattform sind eingetragene Marken des Entwicklers.',
          'PARRAFO5':'Vielen Dank!!',
          'BTN_FINALIZAR':'Fertigstellen und senden',
          'BTN_FINA_REQUE': 'Fertige technische Anforderungen',


        },
        'COPY_MESSAGE':'Schlüssel in die Zwischenablage kopiert',
        'COMPR_CONEXI':'Überprüfung der Verbindung',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'Der Mail-Empfang wurde validiert',
        'MODAL_INSTRUCCI':'Bitte schließen Sie die Registerkarte',
        },
        'FORMULARIO_TI': {
          'TAB': 'Ende des Prozesses',
          'TITULO': 'Rezensentendetails',
          'SUBTITULO': 'Um den Vorgang abzuschließen, geben Sie Ihre Daten in das folgende Formular ein und klicken Sie auf die Schaltfläche Fertig stellen',
          'DONE': 'Der Prozess ist bereits abgeschlossen',
          'FINALIZAR': 'Technische Anforderungen abschließen',
          'NOTYET': 'Der IT-Manager hat den Vorgang noch nicht abgeschlossen, er kann die technischen Anforderungen bestätigen, bis der IT-Manager seine Daten eingegeben hat',
          'FORM': {
            'NOMBRE': 'Name',
            'MAIL': 'Email',
            'FECHA': 'Enddatum',
            'SINENVIAR': 'Daten noch nicht gesendet'
          },
          'MENSAJES': {
            'NOMBRE': 'Sie haben Ihren Namen nicht in das angegebene Feld eingegeben',
            'GUARDANDO': 'Die von Ihnen eingegebenen Informationen werden gespeichert, bitte warten Sie einen Moment',
            'GUARDADO': 'Die Daten wurden korrekt gespeichert'
          }
        },
          'ETI_EMPRE':'Unternehmen',
          'CONTAC':'Kontaktieren Sie uns:',
        'CONTAC_DES':'Wie können wir Ihnen helfen?',
        'SEND_EMA':'Senden Sie eine Nachricht',
        'LABEL':'Beschreibung',
        'TEX_BTN_SEND':'Senden',
        'MODA_SEN_EMAI':'Nachricht senden...',
        'SUCC_MODA_SEN_EMAI':'Die Nachricht wurde erfolgreich gesendet',

    }
  }
};
